import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MailIcon } from './Icons';
const steps = [{
  step: 'Step 1',
  desc: 'You call or text — we answer fast'
}, {
  step: 'Step 2',
  desc: 'We assess your situation (in person or by photos)'
}, {
  step: 'Step 3',
  desc: 'We give you a clear, honest quote'
}, {
  step: 'Step 4',
  desc: 'We schedule your service — often same week'
}, {
  step: 'Step 5',
  desc: 'We show up, do the job, clean up, and leave your yard better than we found it'
}];
export const ContactSection = () => {
  return <section id="contact" className="py-24 bg-forest text-white relative overflow-hidden" data-id="element-17">
      {/* Decorative background */}
      <div className="absolute inset-0 opacity-10" data-id="element-18">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full border-[40px] border-white" data-id="element-19"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full border-[40px] border-white" data-id="element-20"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-21">
        <div className="text-center mb-16" data-id="element-22">
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-23">
            Here's How To Get Started — It's Simple
          </h2>
          <p className="text-xl text-gray-300" data-id="element-24">
            We respond fast. We quote fast. We work fast. Serving all of Orange
            County.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-25">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-26">
            <div className="bg-white/10 backdrop-blur-md p-8 rounded-3xl border border-white/20" data-id="element-27">
              <h3 className="text-2xl font-bold text-accent mb-6 flex items-center gap-3" data-id="element-28">
                <PhoneIcon className="w-6 h-6" data-id="element-29" />
                CALL OR TEXT US NOW:
              </h3>
              <a href="tel:9093717021" className="text-4xl md:text-5xl font-black text-white hover:text-accent transition-colors block mb-2" data-id="element-30">
                (909) 371-7021
              </a>
            </div>

            <div className="bg-white/10 backdrop-blur-md p-8 rounded-3xl border border-white/20" data-id="element-31">
              <h3 className="text-2xl font-bold text-accent mb-6 flex items-center gap-3" data-id="element-32">
                <MailIcon className="w-6 h-6" data-id="element-33" />
                EMAIL US ANYTIME:
              </h3>
              <a href="mailto:southcoasttreecare@gmail.com" className="text-lg sm:text-xl md:text-2xl font-bold text-white hover:text-accent transition-colors" data-id="element-34">
                southcoasttreecare@gmail.com
              </a>
            </div>
          </motion.div>

          {/* Process Steps */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 md:p-10 text-charcoal shadow-2xl" data-id="element-35">
            <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-36">
              WHAT HAPPENS WHEN YOU CALL:
            </h3>
            <div className="space-y-6" data-id="element-37">
              {steps.map((item, index) => <div key={index} className="flex gap-6" data-id="element-38">
                  <div className="flex-shrink-0 w-16 h-16 rounded-2xl bg-earth/10 flex flex-col items-center justify-center text-earth font-bold border border-earth/20" data-id="element-39">
                    <span className="text-xs uppercase tracking-wider" data-id="element-40">
                      Step
                    </span>
                    <span className="text-xl" data-id="element-41">{index + 1}</span>
                  </div>
                  <div className="flex items-center" data-id="element-42">
                    <p className="text-lg font-medium text-gray-800" data-id="element-43">
                      {item.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};